import React from "react";

interface ScanProgressProps {
  progress?: number;
}

export const ScanProgress: React.FC<ScanProgressProps> = ({ progress }) => {
  // Ensure progress is between 0.01 and 1
  const safeProgress = Math.max(0.01, Math.min(progress ?? 0.01, 1));

  return (
    <div className="flex flex-col items-stretch w-full px-4">
      <div className="w-full">
        <div
          className="w-full h-1 bg-[#FCFCFC]/40 rounded"
          style={{ overflow: "hidden" }}
        >
          {/* Animated progress bar */}
          <div
            className="h-1 bg-inverted rounded transition-all duration-300"
            style={{
              width: `${safeProgress * 100}%`,
            }}
          />
        </div>
      </div>
      {/* vertical space 16px */}
      <div style={{ height: 16 }} />
    </div>
  );
};
